export const tableRowStyle = {
  height: 40,
  '& td': {
    padding: '4px 8px',
    fontSize: '14px'
  }
}
